import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-news-details',
  template: require('./news-details.component.html'),
  styles: [require('./news-details.component.css')]
})
export class NewsDetailsComponent implements OnInit {
  private allItems= [
    {
        "name": 1,"imgurl":"http://localhost:4200/assets/img/tq_1.png", "content":"trang 1","title":"Làm thế nào để tìm nguồn hàng hot trend và sản phẩm ngách để kinh doanh?!:"
    },
    {
        "name": 2,"imgurl":"http://localhost:4200/assets/img/tq_1.png", "content":"trang 2","title":"Làm thế nào để tìm nguồn hàng hot trend và sản phẩm ngách để kinh doanh?!:"
    },
    {
        "name": 3,"imgurl":"http://localhost:4200/assets/img/tq_1.png","content":"trang 3","title":"Làm thế nào để tìm nguồn hàng hot trend và sản phẩm ngách để kinh doanh?!:"
    },
    {
        "name": 4,"imgurl":"http://localhost:4200/assets/img/tq_1.png", "content":"trang 4","title":"Làm thế nào để tìm nguồn hàng hot trend và sản phẩm ngách để kinh doanh?!:"
    },
    {
        "name": 5,"imgurl":"http://localhost:4200/assets/img/tq_1.png", "content":"trang 5","title":"Làm thế nào để tìm nguồn hàng hot trend và sản phẩm ngách để kinh doanh?!:"
    },
    {
        "name": 6,"imgurl":"http://localhost:4200/assets/img/tq_1.png", "content":"trang 6","title":"Làm thế nào để tìm nguồn hàng hot trend và sản phẩm ngách để kinh doanh?!:"
    },
    {
        "name": 7,"imgurl":"http://localhost:4200/assets/img/tq_1.png", "content":"trang 7","title":"Làm thế nào để tìm nguồn hàng hot trend và sản phẩm ngách để kinh doanh?!:"
    },
    {
        "name": 8,"imgurl":"http://localhost:4200/assets/img/tq_1.png", "content":"trang 8","title":"Làm thế nào để tìm nguồn hàng hot trend và sản phẩm ngách để kinh doanh?!:"
    },
    {
        "name": 9,"imgurl":"http://localhost:4200/assets/img/tq_1.png", "content":"trang 9","title":"Làm thế nào để tìm nguồn hàng hot trend và sản phẩm ngách để kinh doanh?!:"
    },
    {
        "name": 10,"imgurl":"http://localhost:4200/assets/img/tq_1.png", "content":"trang 10","title":"Làm thế nào để tìm nguồn hàng hot trend và sản phẩm ngách để kinh doanh?!:"
    }];

  content = {
      "name":null,
      "imgurl":"http://localhost:4200/assets/img/tq_1.png",
      "content":"",
      "title":"Trang",
  }
  imgurl : string;

  constructor(private route: ActivatedRoute) { }
  
  ngOnInit() {
    this.getContent()
  }
  getContent(){
    const id = +this.route.snapshot.paramMap.get('id');
    console.log("id",id);
    this.content = this.allItems.find(content=>content.name==id);
    console.log(this.content)
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/news/news-details/news-details.component.ts